import React from 'react'
import { PDFViewer } from './PDFViewer'
import { usePDF } from '@react-pdf/renderer'
import useDownloadZip from 'src/parser/entities/Alarm/UserMenu/useDownloadZip'
import Preview from 'src/parser/entities/Alarm/Preview/Preview'
import Notification from 'src/adminPanel/layout/Notification'
import { useRoundButtonStyles } from './useRoundButtonStyles'

const AlarmPDFViewer = (props): JSX.Element | null => {
  const [pdf] = usePDF({
    document: (
      <Preview
        {...props}
        mode={'download'}
      />
    ),
  })

  const src = typeof pdf.url === 'string' ? `${pdf.url}#toolbar=1` : undefined

  const { entity } = props
  const [downloadZip, state] = useDownloadZip({
    ...props,
    pdf,
    alarm: entity,
  })
  const classes = useRoundButtonStyles()

  if (pdf.loading || pdf.error !== null || pdf.blob === null) {
    return null
  }

  return (
    <>
      <PDFViewer
        src={src}
        pdf={pdf}
        title={props.title}
        showDownloadButton
        loading={state.status === 'running'}
        buttonClasses={classes}
        onDownload={downloadZip}
      />
      <Notification />
    </>
  )
}

export default AlarmPDFViewer
